import React from "react";
import ShareButton from "../ShareButton.jsx";

const FacebookButton = ({ mediaShareURL, shareText, mediaType, gameData, sectionName, showLabel=false }) => {
  let utm = "";
  if (sectionName === "Action Replay") {
    utm = "utm_source=Stories&utm_medium=facebook_share&utm_campaign=action_replay";
  } else if (sectionName === "Group Photo") {
    utm = "utm_source=Stories&utm_medium=facebook_share&utm_campaign=group_photo";
  } else if (sectionName === "Games") {
    utm = "utm_source=Stories&utm_medium=facebook_share&utm_campaign=game_badge";
  } else if (sectionName === "Loop Cams") {
    utm = "utm_source=Stories&utm_medium=facebook_share&utm_campaign=loop_cam";
  }

  const getIconSource = (sectionName) => {
    if (sectionName === "Full Story") {
      return "./img/facebookStoryLink.svg"; // Icon for sharing full story
    }
    return "./img/share_icon_facebook.svg"; // Default white icon for others
  };

  const encodedUrl = encodeURIComponent(mediaShareURL);
  const encodedText = encodeURIComponent(shareText);
  const iconSource = getIconSource(sectionName);

  return (
    <ShareButton
      onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedText}`)}
      source={iconSource}
      btnName="Facebook"
      mediaType={mediaType}
      gameData={gameData}
      sectionName={sectionName}
      btnLabel={showLabel ? "Facebook" : ""}
    />
  );
};

export default FacebookButton;
